module.exports = {
      id: "listicle-usage",
      viewBox: "0 0 10.45 17.376",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#listicle",
      toString: function () {
        return this.url;
      }
    }